/**
 * The «Orçamentos» entry of the sidebar: one item that opens the hub, whose
 * tabs are the module's pages. It reads the module's own permissions, which
 * the host's `AppSubmenu` re-evaluates on every render, so it shows up as
 * soon as they are loaded. The host still passes its `group` helper; the
 * module no longer needs it.
 */
import { HUB_ACCESS, HUB_ITEMS } from "./config";
import { inboxState } from "./inbox";
import { budgetingCanAny } from "./permissions";

// eslint-disable-next-line no-unused-vars
export function buildBudgetingMenu({ group } = {}) {
  return {
    label: "Orçamentos",
    icon: "pi pi-fw pi-calculator",
    to: "/quotes",
    keywords: [
      ...HUB_ITEMS.map((item) => item.label),
      "Orçamentação",
      "orçamento",
      "proposta",
      "cotação",
      "surveys",
      "caixa de entrada",
      "acordo",
      "parceiros",
      "papéis",
      "filiais",
      "tipos de serviço",
      "tabelas de produtos",
    ],
    visible: () => budgetingCanAny(HUB_ACCESS),
    // Read on every render of the menu: the count follows the observable
    get badge() {
      const pending = inboxState().pending;
      return pending > 0 ? String(pending) : null;
    },
  };
}
